import { useEffect, useState } from 'react'
import { Link, useNavigate, useSearchParams } from 'react-router-dom'
import { verifyEmail } from '../services/registrationApi'

type State = 'loading' | 'success' | 'invalid' | 'expired'

export default function VerifyEmailPage() {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const token = searchParams.get('token') ?? ''

  const [state, setState] = useState<State>('loading')

  useEffect(() => {
    if (!token) { setState('invalid'); return }

    verifyEmail(token)
      .then((res) => {
        localStorage.setItem('email_verified', 'true')
        setState('success')
        // Redirect to dashboard or onboarding after a short pause
        const dest = res.onboarding_completed ? '/dashboard' : '/onboarding'
        setTimeout(() => navigate(dest), 2000)
      })
      .catch((err: Error) => {
        setState(err.message === 'token_expired' ? 'expired' : 'invalid')
      })
  }, [token, navigate])

  return (
    <div className="min-h-screen bg-rd-bg font-dmSans flex items-center justify-center px-4">
      <div className="w-full max-w-md text-center">
        {state === 'loading' && (
          <>
            <div className="w-12 h-12 border-4 border-white/10 border-t-green-400 rounded-full animate-spin mx-auto mb-6" />
            <p className="text-rd-muted text-sm">Verifying your email…</p>
          </>
        )}

        {state === 'success' && (
          <>
            <div className="text-5xl mb-5">✅</div>
            <h1 className="font-sora font-bold text-2xl text-rd-text mb-3">Email verified!</h1>
            <p className="text-rd-muted text-sm">Redirecting you to your dashboard…</p>
          </>
        )}

        {state === 'expired' && (
          <>
            <div className="text-5xl mb-5">⏱️</div>
            <h1 className="font-sora font-bold text-2xl text-rd-text mb-3">Link expired</h1>
            <p className="text-rd-muted text-sm mb-6">
              The verification link is older than 24 hours. Log in and request a new one.
            </p>
            <Link
              to="/login"
              className="inline-block px-6 py-3 rounded-lg bg-green-400 text-black font-semibold text-sm"
            >
              Go to login
            </Link>
          </>
        )}

        {state === 'invalid' && (
          <>
            <div className="text-5xl mb-5">❌</div>
            <h1 className="font-sora font-bold text-2xl text-rd-text mb-3">Invalid link</h1>
            <p className="text-rd-muted text-sm mb-6">
              This verification link is invalid or has already been used.
            </p>
            <Link
              to="/login"
              className="inline-block px-6 py-3 rounded-lg bg-green-400 text-black font-semibold text-sm"
            >
              Go to login
            </Link>
          </>
        )}
      </div>
    </div>
  )
}
